module.exports = __webpack_public_path__ + "img/icon-sms.37db8c73.png";